import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

const API_URL = "https://suadesarrollo.azurewebsites.net/api";

const AUTH = {
  username: "BasicAuth@icontec.org",
  password: "yQLzqmR7eZSuAmQZUqhY",
};

const PROCESOS = [
  {
    value: "Sanciones",
    label:
      "La institución tuvo sanciones durante el año inmediatamente anterior por fallas en la calidad de la atención en salud",
  },
  {
    value: "Tutelas",
    label: "Tutelas",
  },
  {
    value: "Investigación",
    label: "La institución tiene algún proceso de investigación en curso",
  },
  {
    value:
      "Manual del Subsistema para la administración del riesgo de corrucion, opacidad o fraude (SICOF)",
    label:
      "Manual del Subsistema para la administración del riesgo de corrución, opacidad o fraude (SICOF)",
  },
];

function CrearControlLegal({ idSolicitud, onCreated }) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [proceso, setProceso] = useState("");
  const [archivos, setArchivos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const abrirModal = () => {
    setError("");
    setModalIsOpen(true);
  };

  const cerrarModal = () => {
    if (loading) return;

    setModalIsOpen(false);
    setProceso("");
    setArchivos([]);
    setError("");
  };

  const handleArchivo = (event) => {
    const archivosSeleccionados = Array.from(event.target.files || []);

    setArchivos(archivosSeleccionados);
    setError("");
  };

  const guardarControlLegal = async (event) => {
    event.preventDefault();

    setError("");

    if (!idSolicitud) {
      setError("No se encontró el ID de la solicitud.");
      return;
    }

    if (!proceso) {
      setError("Debe seleccionar una opción.");
      return;
    }

    if (archivos.length === 0) {
      setError("Debe adjuntar al menos un documento.");
      return;
    }

    try {
      setLoading(true);

      const formData = new FormData();

      archivos.forEach((archivo) => {
        formData.append("files", archivo);
      });

      const response = await axios.post(
        `${API_URL}/CreaControlLegalSolicitud`,
        formData,
        {
          auth: AUTH,
          params: {
            IdSolicitud: idSolicitud,
            Proceso: proceso,
          },
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      console.log("Control legal creado:", response.data);

      alert("¡Control legal creado correctamente!");

      /**
       * Cerrar modal
       */
      cerrarModal();

      /**
       * Actualizar la tabla del componente padre
       */
      if (typeof onCreated === "function") {
        await onCreated();
      }
    } catch (err) {
      console.error("Error al crear control legal:", err);

      let mensaje = "No fue posible crear el control legal.";

      if (err.response) {
        if (err.response.data?.message) {
          mensaje = err.response.data.message;
        } else if (typeof err.response.data === "string") {
          mensaje = err.response.data;
        }
      }

      setError(mensaje);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-primary btn-lg"
        onClick={abrirModal}
      >
        Añadir Control Legal
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={cerrarModal}
        contentLabel="Crear Control Legal"
        ariaHideApp={false}
        shouldCloseOnOverlayClick={!loading}
        shouldCloseOnEsc={!loading}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "850px",
            maxHeight: "90vh",
            padding: "0",
            borderRadius: "8px",
            overflow: "auto",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.65)",
            zIndex: 1050,
          },
        }}
      >
        <div className="card shadow mb-0">
          {/* HEADER */}
          <div className="card-header py-3 d-flex justify-content-between align-items-center">
            <h6 className="m-0 font-weight-bold text-primary">
              Crear Control Legal
            </h6>

            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={cerrarModal}
              disabled={loading}
              title="Cerrar"
            >
              ×
            </button>
          </div>

          {/* BODY */}
          <div className="card-body">
            <form onSubmit={guardarControlLegal}>
              {/* ERROR */}
              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              {/* PROCESO */}
              <div className="form-group">
                <label
                  htmlFor="procesoControlLegal"
                  className="font-weight-bold"
                >
                  Aspecto de Control Legal
                </label>

                <select
                  id="procesoControlLegal"
                  className="form-control"
                  value={proceso}
                  onChange={(e) => setProceso(e.target.value)}
                  disabled={loading}
                >
                  <option value="">Seleccione la opción que aplique</option>

                  {PROCESOS.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* ARCHIVOS */}
              <div className="form-group">
                <label
                  htmlFor="archivosControlLegal"
                  className="font-weight-bold"
                >
                  Documentos soporte
                </label>

                <input
                  id="archivosControlLegal"
                  type="file"
                  className="form-control-file"
                  multiple
                  onChange={handleArchivo}
                  disabled={loading}
                />

                {archivos.length > 0 && (
                  <div className="mt-3">
                    <div className="alert alert-info">
                      <strong>{archivos.length}</strong> documento
                      {archivos.length !== 1 ? "s" : ""} seleccionado
                      {archivos.length !== 1 ? "s" : ""}.
                    </div>

                    <ul className="list-group">
                      {archivos.map((archivo, index) => (
                        <li
                          key={`${archivo.name}-${index}`}
                          className="list-group-item d-flex justify-content-between"
                        >
                          <span>{archivo.name}</span>

                          <small className="text-muted">
                            {(archivo.size / 1024 / 1024).toFixed(2)} MB
                          </small>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              <hr />

              {/* BOTONES */}
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={cerrarModal}
                  disabled={loading}
                >
                  Cancelar
                </button>

                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading || !proceso || archivos.length === 0}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm mr-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Guardando...
                    </>
                  ) : (
                    "Guardar Control Legal"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default CrearControlLegal;
